import { VenueBookmark } from "@iventis/domain-model/model/venueBookmark";
import { mappingApi } from "@iventis/api/src/api";
import { translate } from "@iventis/translations/translation";
import { Content } from "@iventis/translations";
import { VenueBookmarkApiCreateRequest } from "@iventis/domain-model/model/venueBookmarkApiCreateRequest";

export const createVenueBookmark = async (venueBookmark: Partial<VenueBookmark>): Promise<VenueBookmark> => {
    const createRequest: VenueBookmarkApiCreateRequest = {
        name: venueBookmark.name,
        venueId: venueBookmark.venueId,
        thumbnailAssetId: venueBookmark.thumbnailAssetId,
        bearing: venueBookmark.bearing,
        pitch: venueBookmark?.pitch,
        latitude: venueBookmark.latitude,
        longitude: venueBookmark.longitude,
        zoom: venueBookmark?.zoom,
        wgs84Altitude: venueBookmark.wgs84Altitude,
        cameraMode: venueBookmark.cameraMode,
    };
    const response = await mappingApi.post<VenueBookmark>(`/venue-bookmarks`, createRequest, {
        customErrorMessage: {
            title: translate(Content.errors.custom_network_error.create.title, { entity: translate(Content.map10.venue_bookmark) }),
            message: translate(Content.errors.custom_network_error.create.message, { entity: translate(Content.map10.venue_bookmark) }),
        },
    });
    return response.data;
};

export const deleteVenueBookmark = async (venueBookmarkId: string): Promise<string> => {
    await mappingApi.delete(`/venue-bookmarks/${venueBookmarkId}`, {
        customErrorMessage: {
            title: translate(Content.errors.custom_network_error.delete_error.title, { entity: translate(Content.map10.venue_bookmark) }),
            message: translate(Content.errors.custom_network_error.delete_error.message, { entity: translate(Content.map10.venue_bookmark) }),
        },
    });
    return venueBookmarkId;
};

export const getVenueBookmarks = async (): Promise<VenueBookmark[]> => {
    const response = await mappingApi.get<VenueBookmark[]>(`/venue-bookmarks`);
    return response.data;
};
